



















import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';
import Color from 'color';
import {
  NOW_START_MONTH,
  NOW_END_MONTH,
  toCommaFormat,
  sortByAmount,
} from '@/utils';
import type { Stats } from '@/utils';
import Treemap from '@/components/Vivat/Chart/Treemap.vue';

const TreemapArea = defineComponent({
  props: {
    title: {
      type: String,
      default: '',
    },
    query: {
      default: undefined,
    },
    result: {
      type: Function,
      default: undefined,
    },
  },
  components: {
    Treemap,
  },
  setup(props) {
    const filter = reactive({
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
    });
    const { result, loading } = useQuery(
      props.query as any,
      computed(() => ({
        timeframe: filter.monthRange,
      })),
      () => ({
        fetchPolicy: 'network-only',
        enabled: props.query !== undefined && props.result !== undefined,
      }),
    );
    const getDataArray = computed(() => {
      if (loading.value === false && result.value && props.result !== undefined) {
        return props.result(result.value);
      }
      return ([{
        areaCode: 'ไม่มีข้อมูลพื้นที่',
        amount: 0,
      }]);
    });

    const labels: Ref<string[]> = ref([]);
    const dataArray: Ref<number[]> = ref([]);
    const total: Ref<number> = ref(0);
    watch(() => getDataArray.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        const map = (record: Stats) => {
          labels.value.push(record.areaCode);
          dataArray.value.push(record.amount);
          total.value += record.amount;
        };

        labels.value = [];
        dataArray.value = [];
        total.value = 0;
        const arr = [...newVal as Stats[]];
        arr.sort(sortByAmount).forEach(map);
      }
    });

    const data = computed(() => ({
      datasets: [{
        tree: dataArray.value,
        spacing: 2,
        borderRadius: 2,
        backgroundColor: (ctx: any) => {
          const index = ctx.dataIndex;
          const value = ctx.dataset.tree[index] || 0;
          const color = Color('rgba(19,72,137,1)');
          const alpha = (1 + Math.log(value)) / 5;
          return color.alpha(alpha).string();
        },
        labels: {
          display: true,
          color: 'white',
          font: [{ size: 18, weight: 'bold' }],
          formatter: (ctx: any) => {
            const index = ctx.dataIndex;
            const value = ctx.dataset.tree[index] || 0;
            const name = labels.value[index] || '';
            return [name, `${toCommaFormat((value * 100) / total.value)}%`];
          },
        },
      }],
    }));

    return {
      data,
      labels,
      filter,
    };
  },
});

export default TreemapArea;
